import React, { useEffect, useRef } from 'react'
import { Link } from 'gatsby'
import queryString from 'query-string'
import { eventIsPast } from 'shared/utils/dates'
import Icon from 'shared/ui/Icon'
import Card from '../Card'
import PurchaseSuccessMessage from './PurchaseSuccessMessage'
import Checkout from '../Checkout'

export default function PurchaseTickets({ ws }) {
  const ticketSalesEnded = eventIsPast(ws.startDate)
  const query = typeof window !== `undefined` && queryString.parse(window.location.search)

  let dayLabel = null
  if (ws.contentTemplate === 'react-core-first-day') dayLabel = 'first'
  if (ws.contentTemplate === 'react-core-second-day') dayLabel = 'second'

  const ticketsSectionRef = useRef()
  useEffect(() => {
    if ('success' in query) {
      ticketsSectionRef.current.scrollIntoView()
    }
  }, [query])

  return (
    <section className="spacing-small" ref={ticketsSectionRef}>
      <div className="text-small">
        <Link to="/public-workshops" className="icon-text">
          <Icon name="arrow-left" />
          <span>View All Public Workshops</span>
        </Link>
      </div>
      {query && 'success' in query ? (
        <PurchaseSuccessMessage tickets={query.t} code={query.success} />
      ) : (
        <Card className="spacing">
          {ticketSalesEnded ? (
            <p>
              Ticket sales are no longer available since the event is so close to the start time.
            </p>
          ) : (
            <>
              <Checkout
                workshop={{
                  id: ws.id,
                  // startDate: ws.startDate
                }}
              />
              {dayLabel && (
                <>
                  <p>
                    <span aria-label="Star Emoji for Important Information">⭐️</span>{' '}
                    <u>Please Note:</u> This is the {dayLabel} day of what we've normally done as a
                    two-day workshop. Each day is now its own individual event and each needs to be
                    purchased separately if you wish to attend both days.
                  </p>
                  {dayLabel === 'second' && ws.companion && (
                    <p>
                      If you're not attending the first day "{ws.companion}", please see the
                      Pre-Requisite knowledge below.
                    </p>
                  )}
                </>
              )}
            </>
          )}
        </Card>
      )}
    </section>
  )
}
